import service from './request'

export const login = data => {
    return service({
	      showLoading: true,//调用预加载
        url: '/login/login4slf',
        method: 'post',
        data
    })
}
export const ssoLogin = data => {//单点登录接口
    return service({
	      showLoading: true,//调用预加载
        url: '/sso/login',
        method: 'post',
        data
    })
}
//获取密码加密公钥
export const getPublicKey = data => {
  return service({
      showLoading: true,//调用预加载
      url: '/login/getPublicKey',
      method: 'post',
      data
  })
}

//退出登录
export const logout = data => {
    return service({
        url: '/user/logout',
        method: 'post',
        data
    })
}


//修改密码
export const updateUserPwd = data => {
  return service({
    url: "/login/updatePwd",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/http/login.js